<script setup lang="ts">
import { cloneDeep } from 'lodash'

import { AttackPointAttribute } from '@collector/sportsapi-client-legacy'
import { useIncidentGroupComponents } from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/composables/useIncidentGroupComponents'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import FieldZonesModal from '../components/FieldZonesModal/FieldZonesModal.vue'
import { filterAttributesBasedOnSelectedZone } from '../components/FieldZonesModal/utils'
import { zones } from './consts'

interface Props {
  linkedIncident: ProbableLinkedIncident
}
const props = defineProps<Props>()

// emits
const emit = defineEmits(['close'])

// data
const localLinkedIncident = cloneDeep(props.linkedIncident)

// composables
const incidentGroupComponentsComposable = useIncidentGroupComponents(
  localLinkedIncident,
  new Map(),
)
const { updateIncident: _updateIncident, selectedAttributes } =
  incidentGroupComponentsComposable

// methods
function updateIncident(data: { selectedZone: number | null }): void {
  const attributes = filterAttributesBasedOnSelectedZone(
    selectedAttributes.value as AttackPointAttribute[],
    zones,
    data.selectedZone,
  )

  _updateIncident({
    attribute_ids: attributes,
  })

  emit('close')
}
</script>

<template>
  <FieldZonesModal
    :linkedIncident
    :zones
    :incidentParticipantTeamSide="linkedIncident.side!"
    @save="updateIncident"
    @close="$emit('close')"
  />
</template>
